/**
 * Authentication Service
 * Token management utilities
 * Note: API calls are handled by authAPI from models
 */

/**
 * Get stored token from localStorage
 */
export const getToken = () => {
  return localStorage.getItem("token");
};

/**
 * Store token in localStorage
 */
export const setToken = (token) => {
  if (token) {
    localStorage.setItem("token", token);
  } else {
    localStorage.removeItem("token");
  }
};

/**
 * Remove token from localStorage
 */
export const removeToken = () => {
  localStorage.removeItem("token");
};

/**
 * Check if user is authenticated (has valid token)
 */
export const isAuthenticated = () => {
  return !!getToken();
};
